import {
  normalizeCoverageEntries,
  toCoverageEntry,
} from "../providerNetworkHelpers";
import { useAppState } from "./useAppState";

export const useFacilitiesCoverageEntries = () => {
  const { facilities } = useAppState();
  const facilityCoverageEntries = facilities.map(f =>
    toCoverageEntry(f.npi, { latitude: f.latitude, longitude: f.longitude })
  );
  return normalizeCoverageEntries(facilityCoverageEntries);
};
